import { useState } from "react";
import { Link } from "react-router-dom";
import { useRef } from "react";

export default function Search(props) {
  const [text, setText] = useState("");
  const [matches, setMatches] = useState([]);
  const firstRef = useRef(null);
  const [backgroundImg, setBackgroundImg] = useState(
    Math.floor(Math.random() * (2 - 1 + 1)) + 1 //set random image on page load, replace 4 with image amount in folder /assets/backgrounds/
  );
  const fetchArticles = props.data.content.articles;

  const onChangeHandler = (text) => {
    let matches = [];
    if (text.length > 0) {
      matches = fetchArticles.filter((articles) => {
        const regex = new RegExp(`${text}`, "gi");
        return articles.question.match(regex);
      });
    }
    setBackgroundImg(backgroundImg);
    setMatches(matches);
    setText(text);
  };

  const handleClick = () => {
    setMatches("");
    setText("");
  };

  const handleClickSearch = (e) => {
    if (text.length > 2) {
      setMatches("");
      setText("");
    } else {
      e.preventDefault();
    }
  };

  const handleSubmit = (e) => {
    if (text.length > 2) {
      document.querySelector(".searchSubmit").click();
      setMatches("");
      setText("");
    }
    e.preventDefault();
  };

  return (
    <div
      className="search"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/backgrounds/bg${backgroundImg}.jpg`,
      }}
    >
      <div className="search-wrapper">
        <div className="search-inner">
          <h1 className="search-greeting">G'day, we're here to help.</h1>
          <form className="search-form" onSubmit={handleSubmit}>
            <input
              onChange={(e) => onChangeHandler(e.target.value)}
              value={text}
              id="formSearch"
              type="search"
              placeholder="Search articles"
              className="searchInput"
              autoComplete="off"
              ref={firstRef}
              enterKeyHint="search"
            />
            <Link
              className="searchSubmit"
              onClick={handleClickSearch}
              to={`/search/${
                firstRef.length < 1 ? "" : firstRef.current?.value
              }`}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/svg/search.svg`}
                alt="Search"
              />
            </Link>
            <div className="search-matches">
              {text.length > 2 && matches.length > 0 ? <span></span> : ""}
              <ul>
                {text.length > 2
                  ? matches &&
                    matches
                      .filter((match, index) => index < 6)
                      .map((match) => (
                        <li key={match.id}>
                          <Link
                            id={match.id}
                            onClick={handleClick}
                            to={`/article/${match.url}/${match.id}`}
                          >
                            {match.question}
                          </Link>
                        </li>
                      ))
                  : ""}
              </ul>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
